module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Bold.037c5995.ttf";